<template>
  <v-data-table :headers="headers" :items="item.predictions">
    <template #items="{ item }">
      <td>{{ item.classification.id }}</td>
      <td>{{ item.classification.name }}</td>
      <td class="text-xs-right">{{ formatProbability(item.probability) }}</td>
      <td class="text-xs-right">{{ item.modelId }}</td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    headers: [
      {
        text: "Id",
        value: "classification.id",
        align: "left",
        sortable: true
      },
      {
        text: "Clasificación",
        value: "classification.name",
        align: "left",
        sortable: true
      },
      {
        text: "Probabilidad",
        value: "probability",
        align: "right",
        sortable: true
      },
      {
        text: "Modelo",
        value: "modelId",
        align: "right",
        sortable: true
      }
    ]
  }),
  methods: {
    /**
     * Format the given probability to show only two decimals and in a beautiful way.
     * @argument {Number} probability
     */
    formatProbability(probability) {
      return `${(probability * 100).toFixed(2)}%`;
    }
  }
};
</script>